/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75918ResNodesItemTargetTimeObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI75918ResNodesItemDeadLineObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI75918ResNodesItem {
  
  /** 节点ID */
  nodeId?: string;
  
  /** 父节点ID ,String */
  parentIds?: string[];
  
  /** 是否根节点,true:跟节点,false:普通节点 */
  root?: boolean;
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 节点标签 */
  nodeTag?: string;
  
  /** 节点描述 */
  nodeDesc?: string;
  
  /** 岗位 */
  role?: string;
  
  /** 触发方式,timeTarget:时间触发,nodeStart:节点开始触发,nodeEnd：节点完成触发 */
  targetType?: string;
  
  /** 触发时间 ,TimeResp */
  targetTime?: IAPI75918ResNodesItemTargetTimeObj;
  
  /** 截止时间 ,TimeResp */
  deadLine?: IAPI75918ResNodesItemDeadLineObj;
  
};
    
  
    
export interface IAPI75918ResLinesItem {
  
  /** 原节点 */
  from?: string;
  
  /** 指向节点 */
  to?: string;
  
};
    
  



export interface API75918Req {
  
  /** (String) */
  dataId?: string;
    
};



export interface API75918Res {
  /** 数据id  */
  dataId?: string;
  /** 节点 ,NodeResp  */
  nodes?: IAPI75918ResNodesItem[];
  /** 连线 ,LineResp  */
  lines?: IAPI75918ResLinesItem[];
  
};


// 接口函数 75918 查询模型拓扑图

export interface IUseGetAPI75918Return {
  /** 查询模型拓扑图: 接口请求状态 */
  isAPI75918Loading: boolean;
  /** 查询模型拓扑图: 接口请求返回数据 */
  dataAPI75918: API75918Res;
  /**  查询模型拓扑图: 接口数据请求方法 */
  fetchAPI75918Data: (inputs: API75918Req, config?: YWRequestConfig) => Promise<API75918Res>;
  /** 查询模型拓扑图: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI75918 = ():IUseGetAPI75918Return => {
  let isMount = true;
  const [isAPI75918Loading, setIsAPI75918Loading] = useState(false);
  const [dataAPI75918, setDataAPI75918] = useState<API75918Res>({} as API75918Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/get/topology`;

  const fetchAPI75918Data = async (inputs: API75918Req, config?: YWRequestConfig): Promise<API75918Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75918Req>) || {}) as API75918Req;
    
  
    if ( isMount ) {
      setIsAPI75918Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API75918Res>(`${basePath}/yoaichat-web/chat/task/model/get/topology?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI75918(res || {} as API75918Res);
        setIsAPI75918Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75918Loading(false);
      }
      return false as unknown as API75918Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75918Loading,
    dataAPI75918,
    fetchAPI75918Data,
    requestUrl,
  }
}

